import { OAuthProvider, signInWithPopup, getAuth } from 'firebase/auth';

export class FirebaseService {
  static async getFirebaseUserFromProvider(loginProvider: string) {
    const auth = getAuth();
    const provider = new OAuthProvider(loginProvider);
    return await signInWithPopup(auth, provider);
  }
}

export default FirebaseService;
